import config from 'config/appConfig';

/**
 * 利用規約のプレビューURLを取得します。
 */
export function getPreviewUrl(companyCd: string): string {
  return `${config.url.userWeb}/terms/preview/${companyCd}`;
}

/**
 * 利用規約のプレビューURLを開きます。
 */
export function openPreviewUrl(companyCd: string): void {
  window.open(getPreviewUrl(companyCd), '_blank');
}

/**
 * 利用規約の公開URLを取得します。
 */
export function getProductionUrl(companyCd: string): string {
  return `${config.url.userWeb}/terms/${companyCd}`;
}

/**
 * 利用規約の公開URLを開きます。
 */
export function openProductionUrl(companyCd: string): void {
  window.open(getProductionUrl(companyCd), '_blank');
}
